'use client';

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import styles from './Mobile.module.scss';
import Button from '../../../ui/Button/Button';
import useToggle from '../../../../../hooks/useToggle';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import OptimizedImage from '../../../../ui/OptimizedImage/OptimizedImage';

const MAX_TITLE_LENGTH = 87;

const Mobile = memo(function Mobile({ articles, readText, newsButtonDefault, newsButtonOpposite }) {
  const { isOpen, toggle } = useToggle();

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <ul className={styles.list}>
        {articles.slice(0, isOpen ? 5 : 2).map(({ id, url, title, imageUrl, fields }) => {
          const truncatedTitle =
            title.length > MAX_TITLE_LENGTH ? title.slice(0, MAX_TITLE_LENGTH) + '...' : title;

          // 支持多种图片数据结构，与News页面保持一致
          const imageField = fields?.detail?.fields?.image ||
            fields?.image || { value: { src: imageUrl } };

          // 提取图片URL
          const imageSrc = imageField?.value?.src || imageUrl;

          return (
            <div key={id}>
              {url ? (
                <a href={url} className={styles.link}>
                  <motion.li
                    className={styles.card}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div className={styles.imageWrapper}>
                      <OptimizedImage
                        src={imageSrc}
                        alt=""
                        width={400}
                        height={250}
                        loading="lazy"
                        quality={70}
                        device="mobile"
                        objectFit="cover"
                        className={styles.image}
                      />
                    </div>
                    <p className={styles.title}>{truncatedTitle}</p>
                  </motion.li>
                </a>
              ) : (
                <motion.li
                  className={styles.card}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className={styles.imageWrapper}>
                    <OptimizedImage
                      src={imageSrc}
                      alt=""
                      width={400}
                      height={250}
                      loading="lazy"
                      quality={70}
                      device="mobile"
                      objectFit="cover"
                      className={styles.image}
                    />
                  </div>
                  <p className={styles.title}>{truncatedTitle}</p>
                </motion.li>
              )}
            </div>
          );
        })}
      </ul>
      <div className={styles.buttonWrapper}>
        <Button
          variant="secondary"
          isShowTooltip={false}
          className={styles.button}
          onClick={toggle}
        >
          {/* {isOpen ? 'View less' : 'View all'} */}
          {isOpen ? newsButtonOpposite?.value : newsButtonDefault?.value}
        </Button>
      </div>
    </div>
  );
});

export default Mobile;
